const MinhasCompras = () => import('@/views/MinhasCompras.vue');
const FormaPagamento = () => import('@/views/FormaPagamento.vue');

const routes = [
  {
    path: '/minhas-compras',
    name: 'minhas-compras',
    component: MinhasCompras,
    meta: {
      title: 'Minhas compras',
    },
  },
  {
    path: '/minhas-compras/detalhe-compra/:compraId',
    name: 'detalhe-compra',
    component: MinhasCompras,
    meta: {
      title: 'Detalhe da compra',
    },
  },
  {
    path: '/minhas-compras/gerenciar-assinatura/:compraId',
    name: 'gerenciar-assinatura',
    component: MinhasCompras,
    props: route => ({
      compraId: +route.params.compraId,
    }),
    meta: {
      title: 'Gerenciar Assinatura',
    },
  },
  {
    path: '/minhas-compras/gerenciar-pagamento-assinatura/:compraId',
    name: 'forma-pagamento',
    component: FormaPagamento,
    props: route => ({
      compraId: +route.params.compraId,
    }),
    meta: {
      title: 'Forma de pagamento',
    },
  },
];

export default routes;
